export const UNTAGGED = "Untagged";

/**
 * Splits a raw comma-separated tags string into individual, trimmed, non-empty tags, sorted
 * so that tag order doesn't affect equality (e.g. "A, B" and "B, A" parse to the same list).
 */
export function parseTags(tags?: string): string[] {
  return (
    tags
      ?.split(",")
      .map((t) => t.trim())
      .filter(Boolean)
      .sort() ?? []
  );
}
